import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ElektronickaFakturace = {
	name: NAME,
	apiProvider,
	router,
};
